import { render, staticRenderFns } from "./payment_Sunu.vue?vue&type=template&id=4f1754a5&scoped=true"
import script from "./payment_Sunu.vue?vue&type=script&lang=js"
export * from "./payment_Sunu.vue?vue&type=script&lang=js"
import style0 from "./payment_Sunu.vue?vue&type=style&index=0&id=4f1754a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1754a5",
  null
  
)

export default component.exports